module.exports = __webpack_public_path__ + "static/media/13_blanco.b0c85d41.svg";